import { handleValidationChange } from "../CommonValidations/CommonValidaions";

export const validateUser = (data, setError) => {

  /** Required:
   
username
password*/

  var isValid = true;

  if (data.username === "") {
    handleValidationChange("username", true, setError);
    isValid = false;
  } else {
    handleValidationChange("username", false, setError);
  }

  if (data.full_name === "") {
    handleValidationChange("full_name", true, setError);
    isValid = false;
  } else {
    handleValidationChange("full_name", false, setError);
  }

  if (data.role_name === "") {
    handleValidationChange("role", true, setError);
    isValid = false;
  } else {
    handleValidationChange("role", false, setError);
  }

  return isValid;
};
export const validatePassword = (data, setError) => {

  var isValid = true;

  if (data.password === "") {
    handleValidationChange("password", true, setError);
    isValid = false;
  } else {
    handleValidationChange("password", false, setError);
  }


  if (data.confirm_password === "") {
    handleValidationChange("confirm_password", true, setError);
    isValid = false;
  } else {
    handleValidationChange("confirm_password", false, setError);
  }

  return isValid;
};